import React from 'react';

const footer = () => {
    return(
        <footer>
            <div className="container">
                <div className="row">
                    <div className="col-md-6">
                        <a href="https://www.envato.com" target="_blank" rel="noreferrer">
                            <span className="copy">&copy; ENTRINGER.DEV 2022 - Developed by entringer.dev - All rights reserved.</span>
                        </a>
                    </div>
                    <div className="col-md-6">
                        <div className="social-icons">
                            <a href="https://www.linkedin.com/in/fabricioentringer/" target="_blank"><i className="fa fa-linkedin"></i></a>
                            <a href="https://www.instagram.com/fabricio_entringer/" target="_blank"><i className="fa fa-instagram"></i></a>
                            <a href="https://twitter.com/fab_entringer" target="_blank"><i className="fa fa-twitter"></i></a>
                            <a href="https://github.com/fabricio-entringer" target="_blank"><i className="fa fa-github"></i></a>
                        </div>
                    </div>
                </div>
            </div>
        </footer>
    );
}

export default footer;